// Titoli di pagina per document.title (card B del design M3). Spostati da App.tsx senza cambiare
// l'ordine di risoluzione: getPageTitle risolve per prefisso e vince la prima voce che corrisponde.

export const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/my-dashboard': 'La mia dashboard',
  '/leads/inbox': 'Nuovi lead',
  // Card B (design M3): prima di '/leads' (risoluzione per prefisso, vince il primo).
  '/leads/recontacts': 'Ricontatti',
  '/leads': 'Lead',
  '/customers': 'Clienti',
  '/project-proposals': 'Pagine progetto',
  // Card B (design M3): prima di '/contracts'.
  '/contracts/create': 'Nuovo contratto',
  '/contracts': 'Contratti',
  // F-089 (TASK-0343): getPageTitle risolve per prefisso, quindi le due voci piu' specifiche vanno PRIMA di
  // '/backoffice'. '/backoffice/outcome-imports' stava piu' sotto ed era oscurata da '/backoffice'.
  '/backoffice/queue': 'Coda Backoffice',
  '/backoffice/outcome-imports': 'Import Esiti Operatore',
  '/backoffice': 'Dashboard Backoffice',
  '/pipelines': 'Pipeline',
  '/products': 'Prodotti',
  // Card B (design M3): prima mostravano "Equal CRM".
  '/batches': 'Distinte',
  '/jobs': 'Job in background',
  // TASK-0276 (F-022): more specific path listed BEFORE '/finance' below — same
  // insertion-order-matters idiom TASK-0260/TASK-0262 already established for '/commissions/*'.
  '/finance/expenses': 'Spese Aziendali',
  '/finance/supplier-invoices': 'Fatture fornitori',
  // Card B (design M3): prima di '/finance'; prima mostrava solo "Finanza".
  '/finance/costs': 'Controllo costi',
  '/finance/partners': 'Conto Soci',
  '/finance/accountant': 'Commercialista',
  '/finance/bank': 'Banca e riconciliazione',
  '/finance/controls': 'Controlli finanziari',
  '/finance/calendar': 'Scadenziario',
  // Blocco 1 (Card D): prima di '/finance'.
  '/finance/receivables': 'Crediti attesi',
  '/finance/cockpit': 'Cruscotto amministrativo',
  '/finance/practice-payments': 'Movimenti mandante',
  '/finance/pnl': 'Conto economico',
  '/finance': 'Finanza',
  '/operations': 'Operazioni',
  '/settings/users': 'Gestione Utenti',
  '/settings/user-categories': 'Categorie Utenti',
  '/settings/lead-routing-rules': 'Regole di Instradamento Lead',
  '/settings/lead-providers': 'Fornitori Lead',
  '/settings/call-outcomes': 'Esiti Chiamata',
  '/settings/call-center': 'Call center',
  '/settings/lead-rules': 'Regole dei Lead',
  '/settings/lead-statuses': 'Stati dei Lead',
  '/settings/lead-sources': 'Fonti dei Lead',
  '/settings/validation-rules': 'Regole di Completezza',
  '/settings/dynamic-fields': 'Campi della Pratica',
  '/settings/supply-point-types': 'Tipi di fornitura',
  '/settings/feature-flags': 'Feature Flag',
  '/settings/document-templates': 'Modelli Documentali',
  '/settings/automations': 'Automazioni',
  '/settings/next-best-action-rules': 'Regole delle azioni consigliate',
  '/settings/integrations': 'Integrazioni',
  '/settings/business-events': 'Registro Eventi',
  '/settings/configuration-templates': 'Template di Configurazione',
  '/settings/approval-matrix': 'Matrice di Approvazione',
  '/settings/credentials': 'Credenziali',
  // F-093: prima di '/settings' (getPageTitle risolve per prefisso, vince il primo). Qui anche
  // '/settings/implementation-status', che prima era oscurato da '/settings'.
  '/settings/data-quality': 'Qualità dei dati',
  // F-122: prima di '/settings' (getPageTitle risolve per prefisso, vince il primo).
  '/settings/configuration-check': 'Verifica configurazione',
  '/settings/implementation-status': 'Stato Implementazione',
  // F-095: prima di '/settings' (getPageTitle risolve per prefisso, vince il primo).
  '/settings/trash': 'Cestino',
  '/settings': 'Impostazioni',
  '/departments': 'Reparti',
  '/payments': 'Pagamenti',
  // TASK-0260/TASK-0262: more specific paths listed BEFORE '/commissions' below — getPageTitle uses
  // `pathname.startsWith(k)` over Object.entries in insertion order and returns the FIRST match, so
  // both '/commissions/plan-rates' and '/commissions/assignments' must be found before the
  // '/commissions' prefix would also match them.
  '/commissions/plan-rates': 'Listino Provvigionale',
  '/commissions/assignments': 'Assegnazioni',
  // F-083: prima di '/commissions' (getPageTitle risolve per prefisso, vince il primo).
  '/commissions/activity-payouts': 'Provvigioni da attività',
  '/commissions': 'Provvigioni',
  '/team': 'Team',
  '/reports/process': 'Process mining',
  '/reports/executive': 'Cockpit Direzione',
  // F-060: prima di '/reports' (getPageTitle risolve per prefisso, vince il primo).
  '/reports/lead-generation': 'Report Lead Generation',
  '/reports/marketing-economics': 'ROI marketing',
  '/reports/productivity': 'Produttività',
  '/reports/dedicated/revenue': 'Report ricavi',
  '/reports/dedicated/quality': 'Report qualità',
  '/reports/dedicated/backoffice': 'Report backoffice',
  '/reports/dedicated/sectors': 'Report settori',
  '/reports/dedicated/agents': 'Classifica agenti',
  '/reports/penetration': 'Penetrazione prodotti',
  '/reports': 'Report',
  '/targets': 'Obiettivi',
  '/contests': 'Gare',
  '/campaigns': 'Campagne',
  '/audit': 'Audit Log',
  '/outbox': 'Outbox — righe fallite',
  '/platform-health': 'Salute piattaforma',
  // F-112 (TASK-0366): API documentate, solo Admin.
  '/platform/api': 'API documentate',
  '/workstation': 'Postazione Operatore',
  // F-057 (REQ-212-001): coda di lavoro personale, per tutti gli autenticati.
  '/work-queue': 'La mia coda',
  // F-084 (TASK-0338): cruscotto del responsabile del call center.
  '/call-center': 'Cruscotto call center',
  '/executive': 'Dashboard Direzionale',
  '/companies': 'Aziende',
  // F-076: la scheda cliente e le prossime azioni (getPageTitle risolve per prefisso).
  '/contacts': 'Scheda cliente',
  '/next-actions': 'Prossime azioni',
  '/documents': 'Drive',
  '/library': 'Libreria',
  '/forms': 'Form',
  '/funnels': 'Funnel',
  '/approvals': 'Approvazioni',
  '/tickets': 'Ticket & Richieste',
  '/imports': 'Importazioni',
  // F-040 / REQ-032-002: profilo personale — attivazione/disattivazione del secondo fattore.
  '/account/security': 'Sicurezza dell’account',
  // F-043 / REQ-267-001: centro notifiche interno (elenco, preferenze).
  '/notifications': 'Centro Notifiche',
}

export function getPageTitle(pathname: string): string {
  for (const [k, v] of Object.entries(PAGE_TITLES)) {
    if (pathname.startsWith(k)) return v
  }
  return 'Equal CRM'
}
